import React from 'react';
import Search from './components/Search';
import CreateBtn from './components/CreateBtn';
import ResetBtn from './components/ResetBtn';
import SortBy from './components/SortBy/SortBy';
import CountOfItem from './components/CountOfItem';
import { CustomerSelect } from './components/CustomerSelect';
import ChangePositionBtn from './components/ChangePositionBtn';
import { RestaurantSelect } from './components/RestaurantSelect';
import DishSelect from './components/DishSelect';
import WithURLFilters from './components/WithURLFilters';
import style from './ComboGroupControlPanel.module.scss';

const ComboGroupControlPanel: React.FC = () => {
	return (
		<WithURLFilters>
			<div className={style.firstRowWithControls}>
				<Search />
				<CreateBtn />
				<ChangePositionBtn />
			</div>
			<div className={style.secondRowWithControls}>
				<div className={style.selectWrapper}>
					<CustomerSelect />
					<RestaurantSelect />
					<DishSelect />
				</div>
				<div className={style.verticalAlignBlock}>
					<ResetBtn />
					<SortBy />
					<CountOfItem />
				</div>
			</div>
		</WithURLFilters>
	);
};

export default ComboGroupControlPanel;
